<script setup>
import { useCustomFields } from '@/composables/useCustomFields'
import CustomFieldDefaultType from '@/components/customFields/CustomFieldDefaultType.vue'

const { getStatus } = useCustomFields()

const props = defineProps({
    project: {
        type: Object,
        required: true
    },
    unit: {
        type: Object,
        required: true
    },
    fieldKey: {
        type: String,
        required: true
    }
})
</script>
<template>
    <CustomFieldDefaultType :project="props.project" :unit="props.unit" :field-key="props.fieldKey">
        <template #hide="scope">
            <slot name="hide" v-bind="scope" />
        </template>
        <template #hidden="scope">
            <slot name="hidden" v-bind="scope" />
        </template>
        <template #prefix="scope">
            <slot name="prefix" v-bind="scope" />
        </template>
        <template #suffix="scope">
            <slot name="suffix" v-bind="scope" />
        </template>
        <template #default="scope">
            <slot v-bind="scope || {}">
                <template v-for="status of [getStatus(props.project, props.unit)]" :key="status.id">
                    <v-chip size="x-small" :color="status.textColor" variant="flat" label>
                        {{ $getI18n(status.label) }}
                    </v-chip>
                </template>
            </slot>
        </template>
    </CustomFieldDefaultType>
</template>
